import { useNavigate } from 'react-router-dom';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import NotificationsIcon from '@mui/icons-material/Notifications';
import UserIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import WorkIcon from '@mui/icons-material/Work';

import { NotificationType } from 'services/busmanApi/types';

export const ABN = 'ABN 21 143 786 216';

export const USER_ROLES = {
  ADMIN: 'A',
  MANAGER: 'M',
  EMPLOYEE: 'E',
};

export const DESCRIPTION_LIMIT = 255;

export const WORKLOGS_LIMIT = 400;

export const COMPANY_ID = 'd1eed91e-f656-472b-a3cb-7643ba169395';

export const COMPANY_DETAILS = {
  company_name: 'Element Engineering Australia',
  company_address: '5 Carson Rd, Malaga WA 6090',
  company_phone: '+61 8 6262 1111',
  company_email: 'info@elementengineering.com.au',
  company_website: 'https://www.elementengineering.com.au/',
  company_abn: '21 143 786 216',
};

export const TERMS_AND_CONDITIONS =
  'This quote outlines the maximum cost using information supplied at the time of quotation. Any change in the scope will result in a variation or will be time billed in addition to the quoted amount whereby the client will be informed prior. If design objectives cannot be achieved in accordance with relevant standards, the client will be notified and all hours utilised up to this point of discovery will be billed to the client. This quote is subject to Element Engineering Australias terms and conditions available upon request';

export const APP_BAR_TOP_ICONS = [
  { label: 'ME', Icon: UserIcon, permission: 'All', drawer: true },
  { label: 'TEAMS', Icon: GroupsIcon, permission: ['A', 'M'], drawer: true },
];

export const APP_BAR_BOTTOM_ICONS = [
  { label: 'CLIENT', Icon: WorkIcon, permission: ['A', 'M'], drawer: true },
  { label: 'SETTING', Icon: SettingsIcon, permission: ['A'], drawer: true },
  { label: 'NOTIFICATIONS', Icon: NotificationsIcon, permission: 'All', drawer: false },
  { label: 'ACCOUNT', Icon: AccountCircleIcon, permission: 'All', drawer: true },
];

export const createNotificationOnClickMap = (navigate: ReturnType<typeof useNavigate>) => ({
  W: (notification: NotificationType) => navigate(`/worklogs/${notification.related_type_id}`),
  J: (notification: NotificationType) => navigate(`/jobs/${notification.related_type_id}`),
});

export const NOTIFICATION_ICON_MAP = {
  W: ForumOutlinedIcon,
  J: ForumOutlinedIcon,
  // ...add more types as needed
};

export const JOB_TYPE_LABELS: string[] = ['Quoted', 'Time Billed', 'Internal'];
